import outlookOAuthAPI from './oauthOutlookAPI';

async function syncOutlook (params) {
    outlookOAuthAPI(params);
}

export default syncOutlook;